<template>
  <input
    ref="inputRef"
    class="social-homepage-input"
    :placeholder="placeholder"
    @keydown.enter.prevent="onEnter"
    @blur="onBlur"
  >
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
})

const emit = defineEmits(['commit'])
const inputRef = ref(null)

function syncDomValue(val) {
  if (inputRef.value && document.activeElement !== inputRef.value) {
    inputRef.value.value = val || ''
  }
}

onMounted(() => {
  if (inputRef.value) {
    inputRef.value.value = props.modelValue || ''
  }
})

watch(
  () => props.modelValue,
  (val) => {
    syncDomValue(val)
  }
)

function onEnter(e) {
  e.target.blur()
}

function onBlur(e) {
  emit('commit', String(e.target.value || '').trim())
}

defineExpose({
  getValue: () => String(inputRef.value?.value || '').trim(),
  blur: () => inputRef.value?.blur(),
})
</script>

<style scoped>
.social-homepage-input {
  box-sizing: border-box;
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 32px;
  margin: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.2s;
}

.social-homepage-input:hover {
  border-color: #4096ff;
}

.social-homepage-input:focus {
  border-color: #4096ff;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
}
</style>
